import { render, staticRenderFns } from "./CodOrder.vue?vue&type=template&id=dea4d724&scoped=true"
import script from "./CodOrder.vue?vue&type=script&lang=js"
export * from "./CodOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4d724",
  null
  
)

export default component.exports